import { Component, Input } from '@angular/core';

@Component({
  selector: 'atom-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  @Input() iconClass:string = '';
  @Input() iconColor:string = '';

}
